import clsx from "clsx";

import { Header } from "./components/header";
import { Sidebar } from "./components/sidebar";
import classes from "./dashboard-layout.module.css";
import { useMenuItems } from "./use-menu-items";

type DashboardLayoutProps = {
  children?: React.ReactNode;
};

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { MENU_ITEMS, isLoading } = useMenuItems();

  return (
    <div className="flex">
      <Sidebar menuItems={MENU_ITEMS} loading={isLoading} />
      <div className="flex flex-col flex-1">
        <Header />
        <main className={clsx(classes.main, "px-6 py-[42px]")}>
          <div>{children}</div>
        </main>
      </div>
    </div>
  );
};
